export const errorMessage = {
    noNetwork: 'No Internet Connection. Please connect your device to internet and try again',
    serverError: 'A server error occurred. Please contact your administrator.',
    clientError: 'Some thing went wrong. Please contact your administrator.',
    unAuthUser: 'Your login credentials are no longer valid. Please contact your administrator for assistance'
};
